import React from 'react'
import Container from 'js/pages/LandingPages/components/Container'
import Card from 'js/pages/LandingPages/components/Card'
import { PerformanceLandingPage_performanceLandingPage_sections_contentBlocks_ScienceBlockRecord } from '../types/PerformanceLandingPage'
import { FeatureImageType } from 'js/components/FeatureImage'
import { SharedSectionProps } from './types'

type Props =
  PerformanceLandingPage_performanceLandingPage_sections_contentBlocks_ScienceBlockRecord &
    SharedSectionProps

const ScienceSection = ({ title, features }: Props) => {
  return (
    <section className="pt-[52px] md:pt-96">
      <Container>
        <h2 className="quincy max-w-[620px] pb-32 text-32 leading-37 lg:pb-56 lg:text-48 lg:leading-52">
          {title}
        </h2>
        <div className="mb-24 grid gap-x-[40px] gap-y-[16px] lg:grid-cols-3">
          {features.map((item) => (
            <Card
              key={item.heading}
              image={item.image?.responsiveImage as FeatureImageType}
              title={item.heading as string}
              description={item.text as string}
            />
          ))}
        </div>
      </Container>
    </section>
  )
}

export default ScienceSection
